import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: []
})
export class TagManagerModule {
  public static forRoot(): ModuleWithProviders<TagManagerModule> {
    return {
      ngModule: TagManagerModule
    };
  }
}
